/**
 * Storage adapter
 * Claude.ai artifact: uses window.storage (proprietary, cross-session)
 * Standalone:        uses localStorage (per-browser)
 * API is identical — swap without touching component code.
 */

const isClaudeAI = typeof window !== "undefined" && "storage" in window;

export const store = {
  async get<T>(key: string): Promise<T | null> {
    try {
      if (isClaudeAI) {
        // @ts-ignore — window.storage is Claude.ai-specific
        const result = await window.storage.get(key);
        return result ? (JSON.parse(result.value) as T) : null;
      }
      const raw = localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  },

  async set<T>(key: string, value: T): Promise<void> {
    try {
      const serialized = JSON.stringify(value);
      if (isClaudeAI) {
        // @ts-ignore
        await window.storage.set(key, serialized);
      } else {
        localStorage.setItem(key, serialized);
      }
    } catch {
      // Silent fail — storage is best-effort
    }
  },

  async remove(key: string): Promise<void> {
    try {
      if (isClaudeAI) {
        // @ts-ignore
        await window.storage.delete(key);
      } else {
        localStorage.removeItem(key);
      }
    } catch {}
  },
};

// Storage keys
export const KEYS = {
  VOCAB: "lrg-vocab",
  STATS: "lrg-stats",
  HISTORY: "lrg-history",
} as const;
